export const ABO_LAD_HOME_COOKIE_NAME = "home-lad-banner";
export const ABO_LAD_OTHER_COOKIE_NAME = "other-lad-banner";

export const useAbonnementLadBanner = (cookieName) => {

  const cookie = useCookie(cookieName, {
    maxAge: 3600 * 24 * 30
  });

  const isClosedLad = computed(() => {
    return cookie.value === true;
  })

  const closeLadBanner = () => {
    cookie.value = true;
  }

  return { isClosedLad, closeLadBanner }
}